







































































































































  import { ChampFormulaire } from '@/commun/components/champ-formulaire';
  import SectionFormulaire from '@/commun/components/champ-formulaire/section-formulaire/section-formulaire.vue';
  import { TextArea } from '@/commun/components/champ-formulaire/text-area';
  import { TextField } from '@/commun/components/champ-formulaire/text-field';
  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';
  import { DescriptionCoursTextarea } from '@/components/faculte/demandes/formulaires/champs/information-base-cours/description-cours';
  import { SectionFormulaireCours } from '@/components/faculte/demandes/formulaires/creation-cours/section-formulaire-cours';
  import { ChampsInformationComplementaire } from '@/components/faculte/demandes/formulaires/creation-cours/section-information-complementaire/champs-information-complementaire';
  import Vue, { PropType } from 'vue';
  import { Alerte } from '@/commun/components/champ-formulaire/alerte';

  export default Vue.extend({
    name: 'SectionInformationComplementaire',
    components: {
      SectionFormulaire,
      DescriptionCoursTextarea,
      ChampFormulaire,
      TextArea,
      TextField,
      Tooltip,
      Alerte,
    },
    mixins: [SectionFormulaireCours],
    props: {
      afficherAlert: {
        type: Boolean,
        default: false,
      },
      champsAffiches: {
        type: Array as PropType<Array<ChampsInformationComplementaire>>,
        default: () => Object.values(ChampsInformationComplementaire),
      },
    },
    data: () => ({
      maximumCaracteresDescriptionCours: 800,
      maximumCaracteresPrealables: 500,
      maximumCaracteresConcomitants: 500,
      maximumCaracteresSubstitution: 500,
      maximumCaracteresRestrictionsInscription: 500,
      maximumCaracteresPositionnement: 500,
      maximumCaracteresInformationsSupplementaires: 1000,
      champsInformationComplementaire: ChampsInformationComplementaire,
    }),
    methods: {
      afficherChamp(champ: ChampsInformationComplementaire): boolean {
        return this.champsAffiches?.some(
          (champAffiche) => champ === champAffiche
        );
      },
    },
  });
